
import { defineComponent } from "@vue/runtime-core"
import MomentSkeleon from "./moment.vue"
export default defineComponent({
  props: {
    loadingmsg: { type: String, required: false, default: "" }
  },
  components: { MomentSkeleon }
})
